export const data2_4 = [{
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}, {
    name: "",
    m_rn: 0,
    m_adr: 0,
    m_rev: 0,
    lastm_rn: 0,
    lastm_adr: 0,
    lastm_rev: 0,
    varm_rn: 0,
    varm_adr: 0,
    varm_rev: 0,
    y_rn: 0,
    y_adr: 0,
    y_rev: 0,
    lasty_rn: 0,
    lasty_adr: 0,
    lasty_rev: 0,
    vary_rn: 0,
    vary_adr: 0,
    vary_rev: 0,
}];

export const columnsData = (date) => {
    const monthName = new Date(date).toDateString().split(" ")[1];
    return [{
        title: monthName,
        children: [{
            title: "Room Nts",
            key: "m_rn",
            type: "inputNumber"
        }, {
            title: "ADR",
            key: "m_adr",
            type: "number"
        }, {
            title: "Revenue",
            key: "m_rev",
            type: "inputNumber"
        }]
    }, {
        title: `LY ${monthName}`,
        children: [{
            title: "Room Nts",
            key: "lastm_rn",
            type: "inputNumber"
        }, {
            title: "ADR",
            key: "lastm_adr",
            type: "number"
        }, {
            title: "Revenue",
            key: "lastm_rev",
            type: "inputNumber"
        }]
    }, {
        title: `Variance - Monthly`,
        children: [{
            title: "Room Nts",
            key: "varm_rn",
            type: "percent"
        }, {
            title: "ADR",
            key: "varm_adr",
            type: "percent"
        }, {
            title: "Revenue",
            key: "varm_rev",
            type: "percent"
        }]
    }, {
        title: `YTD`,
        children: [{
            title: "Room Nts",
            key: "y_rn",
            type: "inputNumber"
        }, {
            title: "ADR",
            key: "y_adr",
            type: "number"
        }, {
            title: "Revenue",
            key: "y_rev",
            type: "inputNumber"
        }]
    }, {
        title: `LY YTD`,
        children: [{
            title: "Room Nts",
            key: "lasty_rn",
            type: "inputNumber"
        }, {
            title: "ADR",
            key: "lasty_adr",
            type: "number"
        }, {
            title: "Revenue",
            key: "lasty_rev",
            type: "inputNumber"
        }]
    }, {
        title: `Variance - Yearly`,
        children: [{
            title: "Room Nts",
            key: "vary_rn",
            type: "percent"
        }, {
            title: "ADR",
            key: "vary_adr",
            type: "percent"
        }, {
            title: "Revenue",
            key: "vary_rev",
            type: "percent"
        }]
    }]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-4/data.js